import React, { useEffect, useState } from 'react';
import '../styles/login.css'
import { ButtonGB } from '../components/buttonGB';
import { InputGB } from '../components/inputGB';
import perfil from '../img/profile.png'
import izq from "../img/izq.png"
import top from "../img/top.png"
import bottom from "../img/bottom.png"
import useGetResolution from '../functions/useGetResolution';

function Login(props) {
    const { login } = props;
    const [validated, setValidated] = useState(false);
    const [validateToken, setValidateToken] = useState(false);
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const resolution = useGetResolution();

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        setValidated(false);
        login(user, password);
        if (validated !== false) {
            if (form.checkValidity() === false) {
                setValidated(true);
            }
            else {
                login(user, password);
            }
        }
    };

    return (
        <div>
            <div className='login-box flex items-center justify-center'>
                {
                    (resolution === "lg") && (
                        <h1 className='form-title'>DESCUBRE LA<br />NUEVA FORMA DE<br />HACER LAS<br />TRANSCRIPCIONES<br />DE TUS<br />GRABACIONES</h1>
                    )
                }
                <form onSubmit={handleSubmit} className='card card-container flex justify-center'>
                    <div className="login-form">
                        <div className='flex justify-center'>
                            <img
                                className='perfil-login'
                                src={perfil}
                            />
                        </div>
                        <InputGB
                            required={true}
                            value={user}
                            onChange={(e) => setUser(e.target.value)}
                            label={"Usuario"}
                            name={"user"}
                        />
                        <InputGB
                            required={true}
                            type='password'
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            label={"Contraseña"}
                            name={"password"}
                        />
                    </div>
                    <ButtonGB
                        text={"Iniciar Sesión"}
                        type={"submit"}
                    />
                    <p className='login-forget-password text-blue cursor-pointer flex justify-center' onClick={() => document.getElementById('my_modal_3').showModal()}>Olvidé mi contraseña</p>
                </form>
                {
                    (resolution === "lg" || resolution === "md") && (
                        <img
                            className='izq-img'
                            src={izq}
                        />
                    )
                }
                <dialog id="my_modal_3" className="modal">
                    <div className="modal-box">
                        <form method="dialog">
                            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                        </form>
                        <h3 className="font-bold text-lg">Recuperar Contraseña</h3>
                        {
                            validateToken ? (
                                <>
                                    <p className="py-4">Por favor, ingresa el token enviado.</p>
                                    <label className="input input-bordered focus:border-hidden flex items-center gap-2">
                                        <input type="text" className="grow" placeholder="Token" />
                                    </label>
                                    <div className='flex justify-center'>
                                        <button className="btn bg-green-500 hover:bg-green-400 hover:border-success text-white">Comprobar Token</button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <p className="py-4">Por favor, ingresa tu correo electronico. Te enviaremos un token para restablecer tu contraseña.</p>
                                    <h2 className="font-bold text-sm">Pasos:</h2>
                                    <p className="py-4">1. Ingresa tu correo electronico en el campo proporcionado <br />2. Presiona el boton "Enviar token de recuperacion".<br />3. Revisa tu correo electronico para obtener el token de recuperacion de contraseña.<br />4. Copia el token enviado, pegalo en el campo de Token, escribe tu nueva contraseña y da click en el boton "Confirmar Contraseña".</p>
                                    <label className="input input-bordered focus:border-hidden flex items-center gap-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 16 16"
                                            className="h-4 w-4 opacity-70">
                                            <path
                                                d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
                                            <path
                                                d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
                                        </svg>
                                        <input type="email" className="grow" placeholder="Email" />
                                    </label>
                                    <p className="py-4 text-gray-500 text-xs">Tu privacidad es importante para nosotros. No compartiremos tu correo electronico con terceros.</p>
                                    <form method="dialog">
                                        <div className='flex justify-center'>
                                            <button className="btn bg-green-500 hover:bg-green-400 hover:border-success text-white" onClick={() => setValidateToken(true)}>Enviar token de recuperacion</button>
                                        </div>
                                    </form>
                                </>
                            )
                        }
                    </div>
                </dialog>
            </div>
        </div>
    );
}

export default Login;